import { prepareMoviesData } from '../../utils/prepareMoviesData';
import { getMoviesJsonForEnUs } from '../../utils/getMoviesJsonForEnUs';
import laVitaEBellaImageUrl from './assets/la-vita-e-bella-1997.jpg';
import laVitaEBellaPreviewImageUrl from './assets/la-vita-e-bella-1997_preview.png';
import ilPostinoImageUrl from './assets/il-postino-1994.jpg';
import iCentoPassiImageUrl from './assets/i-cento-passi-2000.jpg';
import nuovoCinemaParadisoImageUrl from './assets/nuovo-cinema-paradiso-1988.jpg';
import lazzaroFeliceImageUrl from './assets/lazzaro-felice-2018.jpg';
import sottoIlSoleDiRiccioneImageUrl from './assets/sotto-il-sole-di-riccione-2020.jpg';
import ladriDiBicicletteImageUrl from './assets/ladri-di-biciclette-1948.jpg';
import realityImageUrl from './assets/reality-2012.jpg';
import laVitaDavantiImageUrl from './assets/la-vita-davanti-a-se-2020.jpg';
import nataleStelleImageUrl from './assets/natale-a-5-stelle-2018.jpg';
import totoPeppinoMalafemminaImageUrl from './assets/toto-peppino-e-la-malafemmina-1956.jpg';
import laGrandeBellezzaImageUrl from './assets/la-grande-bellezza-2013.jpg';
import mettiUnaSeraImageUrl from './assets/metti-una-sera-a-cena-1969.jpg';
import mineVagantiImageUrl from './assets/mine-vaganti-2010.jpg';
import siViveUnaVoltaImageUrl from './assets/si-vive-una-volta-sola-2021.jpg';
import italianMoviesJSON from './italianMovies.data.json';

const images = {
  posters: {
    'la-vita-e-bella-1997': laVitaEBellaImageUrl,
    'il-postino-1994': ilPostinoImageUrl,
    'i-cento-passi-2000': iCentoPassiImageUrl,
    'nuovo-cinema-paradiso-1988': nuovoCinemaParadisoImageUrl,
    'lazzaro-felice-2018': lazzaroFeliceImageUrl,
    'sotto-il-sole-di-riccione-2020': sottoIlSoleDiRiccioneImageUrl,
    'ladri-di-biciclette-1948': ladriDiBicicletteImageUrl,
    'reality-2012': realityImageUrl,
    'la-vita-davanti-a-se-2020': laVitaDavantiImageUrl,
    'natale-a-5-stelle-2018': nataleStelleImageUrl,
    'toto-peppino-e-la-malafemmina-1956': totoPeppinoMalafemminaImageUrl,
    'la-grande-bellezza-2013': laGrandeBellezzaImageUrl,
    'metti-una-sera-a-cena-1969': mettiUnaSeraImageUrl,
    'mine-vaganti-2010': mineVagantiImageUrl,
    'si-vive-una-volta-sola-2021': siViveUnaVoltaImageUrl,
  },
  previews: {
    'la-vita-e-bella-1997': laVitaEBellaPreviewImageUrl,
  },
};

export const italianMovies = prepareMoviesData(italianMoviesJSON, images);

export const italianMoviesForEnUs = prepareMoviesData(
  getMoviesJsonForEnUs(italianMoviesJSON),
  images,
);
